import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DraggableList from 'react-draggable-list';
import uuid from 'uuid/v4';
import { cloneDeep } from 'lodash';
import { FormGroup, Button, Icon } from 'components';
import CheckBoxOption from './components/CheckBoxBuilderOption/CheckBoxBuilderOption';
import styles from './CheckBoxBuilder.scss';

const CheckBoxBuilder = ({
    defaultValue,
    isDisabled,
    onChange,
    canAddItems,
    addItemButtonText,
    newItemPlaceholder
}) => {
    const [items, setItems] = useState(defaultValue);

    const getItemIndex = (index) => items.findIndex(item => item.index === index);

    const handleDelete = index => {
        const foundIndex = getItemIndex(index);
        const updatedItems = [
            ...items.slice(0, foundIndex),
            ...items.slice(foundIndex + 1)
        ];
        onChange(updatedItems);
        setItems(updatedItems);
    };

    const handleAdd = () => {
        const newItem = { index: uuid(), item: '', checked: false };
        const updatedItems = items.concat(newItem);
        onChange(updatedItems);
        setItems(updatedItems);
    };

    const handleTextChange = (event, index) => {
        event.stopPropagation();
        const foundIndex = getItemIndex(index);
        const updatedItem = { ...items[foundIndex] };
        updatedItem.item = event.target.value;
        const updatedItems = cloneDeep(items);
        updatedItems[foundIndex] = updatedItem;
        onChange(updatedItems);
        setItems(updatedItems);
    };

    const handleMoveItems = (newItemsList) => {
        onChange(newItemsList);
        setItems(newItemsList);
    };

    return (
        <div className={styles.container}>
            <FormGroup className={styles.formGroup}>
                <DraggableList
                    list={items}
                    itemKey='index'
                    onMoveEnd={handleMoveItems}
                    template={CheckBoxOption}
                    commonProps={{
                        onChangeItemText: handleTextChange,
                        onRemoveItem: handleDelete,
                        isDisabled: isDisabled,
                        newItemPlaceholder: newItemPlaceholder
                    }}
                />
                {
                    canAddItems &&
                        <Button
                            className={styles.addButton}
                            onClick={handleAdd}
                            disabled={isDisabled}
                            aria-label={addItemButtonText}
                        >
                            <Icon className={styles.addIcon} name='ion-md-add' />
                            <div className={styles.iconText}>
                                { addItemButtonText }
                            </div>
                        </Button>
                }
            </FormGroup>
        </div>
    );
};

CheckBoxBuilder.propTypes = {
    defaultValue: PropTypes.arrayOf(PropTypes.shape({
        index: PropTypes.string,
        item: PropTypes.string,
        checked: PropTypes.bool
    })),
    isDisabled: PropTypes.bool,
    onChange: PropTypes.func,
    canAddItems: PropTypes.bool,
    addItemButtonText: PropTypes.string,
    newItemPlaceholder: PropTypes.string
};

CheckBoxBuilder.defaultProps = {
    defaultValue: [
        { index: uuid(), item: '', checked: false },
        { index: uuid(), item: '', checked: false },
        { index: uuid(), item: '', checked: false }
    ],
    isDisabled: false,
    onChange: () => {},
    canAddItems: true,
    addItemButtonText: '',
    newItemPlaceholder: ''
};

export default CheckBoxBuilder;
